import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue";
var _hoisted_1 = {
  class: "availability-info-wrapper"
};

var _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1);

var _hoisted_3 = {
  key: 0
};

var _hoisted_4 = /*#__PURE__*/_createElementVNode("br", null, null, -1);

var _hoisted_5 = {
  class: "dialog-footer d-flex flex-row fl-j-c"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_el_button = _resolveComponent("el-button");

  var _component_el_dialog = _resolveComponent("el-dialog");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_dialog, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
      return _ctx.dialogVisible = $event;
    }),
    title: _ctx.$t('availability-info.title'),
    "show-close": false,
    "lock-scroll": true,
    "close-on-press-escape": false,
    "close-on-click-modal": false
  }, {
    footer: _withCtx(function () {
      return [_createElementVNode("span", _hoisted_5, [_createVNode(_component_el_button, {
        type: "primary",
        onClick: _cache[0] || (_cache[0] = function ($event) {
          return _ctx.pssRemovalConfirmation();
        })
      }, {
        default: _withCtx(function () {
          return [_createTextVNode(_toDisplayString(_ctx.$t("availability-info.ok-button")), 1)];
        }),
        _: 1
      })])];
    }),
    default: _withCtx(function () {
      return [_createElementVNode("p", null, _toDisplayString(_ctx.$t("availability-info.description")), 1), _hoisted_2, _ctx.noAvailabilityInfo && _ctx.noAvailabilityInfo.length ? (_openBlock(), _createElementBlock("div", _hoisted_3, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.noAvailabilityInfo, function (info) {
        return _openBlock(), _createElementBlock("div", {
          key: String(info.categoryId) + String(info.priceId),
          class: "info-row"
        }, [_createElementVNode("p", null, [_createElementVNode("strong", null, _toDisplayString(info.categoryName) + " - " + _toDisplayString(info.priceName), 1)]), _createElementVNode("p", null, _toDisplayString(_ctx.$t("availability-info.available")) + " " + _toDisplayString(info.dbAvailability), 1), _createElementVNode("p", null, _toDisplayString(_ctx.$t("availability-info.booked")) + " " + _toDisplayString(info.bookedQty), 1)]);
      }), 128)), _hoisted_4])) : _createCommentVNode("", true)];
    }),
    _: 1
  }, 8, ["modelValue", "title"])]);
}